<template>
    <div 
        class="container mx-auto mb-120px"
        :class="`section-${section.slug}`">

        <div class="relative flex flex-col justify-between text-waheed text-purple-brown mb-30px sm:mx-8 xl:mx-0 lg:flex-row">
            <div class="relative z-10 text-center">
                <button 
                    class="section-sub-titles section-sub-titles-main w-full cursor-pointer text-40px px-1"
                    :class="{ 'active' : activeSlug === section.slug }"
                    v-on:click.prevent="fetchArticles(section.slug)">
                    {{ section.name }}
                </button>
            </div>

            <div
                v-if="section.related_tags.length > 0" 
                class="relative z-20 flex items-end lg:justify-center overflow-x-auto hide-scrollbars">
                <button
                    v-for="tag,tagIndex in section.related_tags"
                    :key="tagIndex" 
                    class="flex-shrink-0 section-sub-titles text-21px px-1 lg:ml-0 lg:mr-60px mx-6
                    first:text-red-600"
                    :class="{ 'active': activeSlug === tag.slug }"
                    v-on:click.prevent="fetchArticles(tag.slug)">
                    {{ tag.label }}
                </button>
            </div>
            
            <div class="absolute bottom-0 w-full border-t-2 border-whiteish"></div>
        </div>

        <!-- LOADING -->
        <div v-if="true === isLoading">
            <SectionThreeLoadingComponent />
            <!-- <SectionTwoLoadingComponent /> -->
        </div>

        <!-- COMPONENT -->
        <div v-else>
            <component 
                v-bind:is="activeSectionComponent"
                :data="data"
                :slug="sectionSlug"></component>
        </div>
    </div>
</template>

<script>
import SectionTwoLoadingComponent from '../Loading/Section/SectionTwoLoadingComponent.vue'
import SectionThreeLoadingComponent from '../Loading/Section/SectionThreeLoadingComponent.vue'

import SectionTwoComponent from './Layout/SectionTwoComponent.vue'
import SectionThreeComponent from './Layout/SectionThreeComponent.vue'

import axios from 'axios'

export default{
    props: ['section'],
    data() {
        return {
            sectionSlug: null,
            activeSlug: null,
            isLoading: true,
            data: null,
        }
    },
    computed: {
        activeSectionComponent() {
            if (this.activeSlug !== this.sectionSlug) {
                return `SectionThreeComponent`
            }

            return `Section${this.capitalize(this.section.layout)}Component`
        }
    },
    components: {
        SectionTwoLoadingComponent,
        SectionThreeLoadingComponent,
        SectionTwoComponent,
        SectionThreeComponent,
    },
    methods: {
        capitalize(s) {
            return s[0].toUpperCase() + s.slice(1)
        },
        fetchArticles(slug) {
            this.isLoading = true
            this.activeSlug = slug

            const url = 'section'

            const layout = this.activeSlug !== this.sectionSlug ?
                'three' :
                this.section.layout

            axios.post(url, {
                slug,
                layout: layout,
                type: 'sections'
            }).then(resp => {
                this.data = resp.data

                this.isLoading = false
            }).catch(e => {
                console.error(e)
            })
        }
    },
    beforeMount() {
        this.isLoading = true

        const slug = this.section.slug

        this.activeSlug = slug
        this.sectionSlug = slug
        this.fetchArticles(slug)
    }
}
</script>
